export function buildTechArticleSchema({ siteUrl, siteName, contentPage, pageUrl, locale = 'fr' }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'TechArticle',
    headline: contentPage.title,
    description: contentPage.description,
    url: pageUrl,
    dateModified: contentPage.modified,
    author: {
      '@type': 'Organization',
      name: siteName,
      url: siteUrl,
    },
    publisher: {
      '@type': 'Organization',
      name: siteName,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/logo.png`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageUrl,
    },
    inLanguage: locale === 'en' ? 'en-US' : 'fr-FR',
    proficiencyLevel: 'Expert',
    dependencies: locale === 'en'
      ? 'WebRTC, enterprise network infrastructure'
      : 'WebRTC, infrastructure réseau entreprise',
  };
}
